import React, { useState } from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import FileUpload from 'components/Inputs/FileUpload';
import Loader from 'components/Loader/Loader';
import { parseCSV } from 'helpers/parseFile';
import { API_URL } from '../../configs/Api';
import { getHeaders } from '../../middleware/Api';
const styles = require('./styles.pcss');

type Props = {
  enqueueSnackBarMessage: Function;
  organizationId: string;
};

export default function BulkDepartmentUploadTool(props: Props) {
  const [csvFile, setCsvFile] = useState<File | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleUpload = async () => {
    if (!csvFile) {
      props.enqueueSnackBarMessage('Must upload CSV file.', 'error');
      return;
    }
    setIsLoading(true);

    try {
      const parsedData = await parseCSV(csvFile);
      if (parsedData.length <= 0) throw new Error('No data to upload');
      else {
        const columns = Object.keys(parsedData[0]);
        const whiteList = ['Department Name', 'External ID'];
        if (columns.some((col) => !whiteList.includes(col)))
          throw new Error(
            'incorrect csv headers, can only have "Department Name" and "External ID"',
          );
        if (parsedData.some(col => !col['Department Name']))
          throw new Error(
            'All rows must have a value for "Department Name" column.'
          );
      }
      const res = await (
        await fetch(API_URL + 'job/import-departments', {
          method: 'post',
          headers: getHeaders(),
          body: JSON.stringify({
            organizationId: props.organizationId,
            data: parsedData.map(datum => ({name: datum['Department Name'], externalId: datum['External ID']})),
            fileContent: await csvFile.text(),
          }),
        })
      ).json();
      if (res.type === 'data') {
        props.enqueueSnackBarMessage('Departments are processing. Please check app in a few minutes.', 'success')
      }
    } catch (e: any) {
      props.enqueueSnackBarMessage('Error: ' + e.message, 'error');
    } finally {
      setIsLoading(false);
    }
  };

  const handleFileChange = (files: FileList) => {
    if (files[0]) {
      setCsvFile(files[0]);
    }
  };

  return (
    <Card className={styles.bulkCategoryUploadCard}>
      <CardHeader
        title="Bulk Department Upload Tool"
        className={styles.header}
      />
      <CardContent>
        <Typography
          variant="body1"
          className={styles.description}
        >
          Use this tool to upload departments in bulk. Click the button below to
          start the process.
        </Typography>

        <FileUpload
          onChange={handleFileChange}
          value={csvFile}
          mimeType="text/csv"
        />

        <div className={styles.buttonContainer}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleUpload}
            className={styles.button}
            disabled={isLoading}
          >
            Upload Departments
          </Button>
        </div>
      </CardContent>
      {isLoading && (
        <div className={styles.infoLoader}>
          <Loader visible={true} />
        </div>
      )}
    </Card>
  );
}
